<div class="genderSelector__title">
  <app-ds-typography
    [size]="typographyFontSize.XXS"
    [tag]="'p'"
    [color]="typographyColor.Primary"
    [text]="'BOOKING_MODULE.GENDER' | transloco">
  </app-ds-typography>
</div>
<div class="genderSelector__radios">
  <div class="genderSelector__radio--male">
    <app-ds-radio-button
      [isFailed]="addErrorClass(idSelector)?.error"
      [failedType]="radioButtonFailedType"
      [checked]="isMale"
      [title]="{ Label: 'BOOKING_MODULE.MALE' | transloco }"
      (radioOnChecked)="setValue(male)">>
    </app-ds-radio-button>
  </div>
  <div class="genderSelector__radio--female">
    <app-ds-radio-button
      [isFailed]="addErrorClass(idSelector)?.error"
      [failedType]="radioButtonFailedType"
      [checked]="isFemale"
      [title]="{ Label: 'BOOKING_MODULE.FEMALE' | transloco }"
      (radioOnChecked)="setValue(female)">
    </app-ds-radio-button>
  </div>
</div>
<div class="genderSelector__error" *ngIf="addErrorClass(idSelector)?.error">
  <app-ds-typography
    [size]="typographyFontSize.XXXS"
    [tag]="'p'"
    [text]="'BOOKING_MODULE.PAX.ERRORS.MANDATORY_FIELD' | transloco"
    [color]="typographyColor.Warning">
  </app-ds-typography>
</div>